import { render, staticRenderFns } from "./CardNavigation.vue?vue&type=template&id=4f30b39c"
import script from "./CardNavigation.vue?vue&type=script&lang=js"
export * from "./CardNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports